module.exports = __webpack_public_path__ + "static/img-main-be8b8a43bed63ef27934b679198ba849.jpg";